export default "<div data-component=\"app-empty-box\">\n  <p>{{ message }}</p>\n</div>\n"